import { render, staticRenderFns } from "./qiaoliangAdd.vue?vue&type=template&id=f20e7e3a&scoped=true"
import script from "./qiaoliangAdd.vue?vue&type=script&lang=js"
export * from "./qiaoliangAdd.vue?vue&type=script&lang=js"
import style0 from "./qiaoliangAdd.vue?vue&type=style&index=0&id=f20e7e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20e7e3a",
  null
  
)

export default component.exports